import { useState, type CSSProperties } from 'react'
import { IconButton } from '../Buttons'
import { KeyboardArrowLeft, KeyboardArrowRight } from '../Icons'
import { Stack, type StackProps } from '../Layout'
import { MobileStepper } from './mui'

export function ImageStepper({ children, ...props }: StackProps) {
  const [activeStep, setActiveStep] = useState(0)
  const images = getImages(children)
  const maxSteps = images.sources.length

  return (
    <Stack {...props}>
      <img
        src={images.sources[activeStep]}
        alt={images.descriptions[activeStep]}
        width={images.widths[activeStep]}
        height={images.heights[activeStep]}
        style={images.styles[activeStep]}
      />
      <MobileStepper
        variant='dots'
        steps={maxSteps}
        activeStep={activeStep}
        position='static'
        sx={{
          bgcolor: 'inherit',
          '&>.MuiMobileStepper-dots': {
            '&>.MuiMobileStepper-dot': { bgcolor: 'grey.300', height: 12, width: 12 },
            '&>.MuiMobileStepper-dotActive': { bgcolor: 'common.black' },
          },
        }}
        nextButton={
          <IconButton
            onClick={() => setActiveStep(prevActiveStep => prevActiveStep + 1)}
            disabled={activeStep === maxSteps - 1}
          >
            <KeyboardArrowRight fontSize='large' />
          </IconButton>
        }
        backButton={
          <IconButton onClick={() => setActiveStep(prevActiveStep => prevActiveStep - 1)} disabled={activeStep === 0}>
            <KeyboardArrowLeft fontSize='large' />
          </IconButton>
        }
      />
    </Stack>
  )
}

const getImages = (children: React.ReactNode) => {
  const images: ImagesType = { sources: [], descriptions: [], heights: [], widths: [], styles: [] }

  if (Array.isArray(children)) {
    children.forEach(child => {
      images.sources.push(child.props.src)
      images.descriptions.push(child.props.alt)
      images.heights.push(child.props.height)
      images.widths.push(child.props.width)
      images.styles.push(child.props.style)
    })
  }

  return images
}

type ImagesType = {
  sources: string[]
  descriptions: string[]
  heights: number[]
  widths: number[]
  styles: CSSProperties[]
}
